<template>
  <!-- Main -->
  <div id="main">
    <!-- 掃瞄器 -->
    <div id="mainHardware">
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">掃瞄機</span>
              <hover-text text="新增">
                <a class="add" @click="addScanner()"><FontAwesomeIcon icon="plus"/></a>
              </hover-text>
            </div>
            <table>
              <tr>
                <th><span class="content">名稱</span></th>
                <th><span class="content">序號</span></th>
                <th></th>
              </tr>
              <tr class="edit" v-show="newScanner.display">
                <td align="center">
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 150px;"
                    v-model="newScanner.name"
                  />
                </td>
                <td align="center">
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 150px;"
                    v-model="newScanner.sn"
                  />
                </td>
               
                <td align="center">
                  <div class="action">
                    <hover-text v-show="!newScanner.loading" text="儲存">
                      <a @click="saveNewScanner()"><FontAwesomeIcon icon="save"/></a>
                    </hover-text>
                    <a v-show="newScanner.loading"><FontAwesomeIcon icon="spinner"/></a>
                    <hover-text text="取消">
                      <a @click="dropNewScanner()"><FontAwesomeIcon icon="times"/></a>
                    </hover-text>
                  </div>
                </td>
              </tr>

              <tr :class="{ edit: scanner.editMode }" 
                v-for="(scanner, index) in scanners"
                :key="'scanner' + index">                
                <td align="center">
                  <span class="content" v-show="!scanner.editMode">{{ scanner.name }}</span>
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 150px;"
                    v-show="scanner.editMode"
                    v-model="scanner.name"
                  />
                </td>
                <td align="center">
                  <span class="content">{{ scanner.sn }}</span>
                </td>
                
                <td align="center">
                  <div class="action">
                    <hover-text text="編輯" v-show="!scanner.editMode"><a @click="editScanner(index)"><FontAwesomeIcon icon="pen"/></a></hover-text>
                    <hover-text text="儲存" v-show="scanner.editMode"><a @click="saveScanner(index)"><FontAwesomeIcon icon="save"/></a></hover-text>
                    <hover-text text="刪除" v-show="!scanner.editMode"><a @click="removeScanner(index)"><FontAwesomeIcon icon="trash"/></a></hover-text>
                    <hover-text text="取消" v-show="scanner.editMode"><a @click="abandonEditScanner(index)"><FontAwesomeIcon icon="times"/></a></hover-text>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import HoverText from "src/components/HoverText.vue";
import { fetchScannersUnderShop } from "src/javascripts/generalPages/fetchData";
import { fetchSettings } from "src/javascripts/generalPages/fetchForConsoleLog";
import { createScanner} from "src/javascripts/generalPages/postData";
import { deleteScanner } from "src/javascripts/generalPages/deleteData";
import { updateScanner } from "src/javascripts/generalPages/updateData";


export default {
  components: {
    FontAwesomeIcon,
    HoverText
  },
  data() {
    return {
      shop: {
        shopId: "",
        shopName: ""
      },
      scanners: [],
      
      // 新增掃瞄機預設
      newScanner: {
        display: false,
        loading: false,
        name: "",
        sn: ""
      },
      tempScanner: {
        display: false,
        name: "",
        sn: ""
      },
      editList: []
    };
  },
  computed: {
    type() {
      return this.$route.params.type || 'gaa';
    },
    scannersIsEditing: function() {
      let index = this.scanners.findIndex(scanner => scanner.editMode);
      return index !== -1 || this.newScanner.display;
    }
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    }
  },
  created: function() {   
    // initial fetch scanners
    fetchSettings(this.accountId, this.$route.params.type)
      .then(settingRes => {
        this.shop.shopId = settingRes.data[0].shop_id;
        this.shop.shopName = settingRes.data[0].name;
        return this.getScanners();
      });
  },
  methods: {
    getScanners() {
      console.log('getScanners')
      return fetchScannersUnderShop(this.accountId, this.type)
        .then(fetchScannersRes => {
          console.log(fetchScannersRes);
          this.scanners = fetchScannersRes.data;
          this.scanners.forEach(scanner => {
            scanner.editMode = false;
          })
        })
        .catch(fetchScannersErr => {
          console.log("fetchScannersErr: ", fetchScannersErr);
          this.scanners = [];
          this.$message({
            type: "error",
            message: `商店：${this.accountId} ，無法取得掃瞄機資料`
          });
        })
    },
    addScanner() {
      this.newScanner.display = true;
    },
    resetNewScanner() {
      this.newScanner = Object.assign(this.newScanner, 
      {
        display: false,
        loading: false,
        name: "",
        sn: ""
      });
    },
    async saveNewScanner() {
      let newScanner = {...this.newScanner};
      if (this.InvalidInput(newScanner)) return;
      this.newScanner.loading = true;
      // 先綁定後更新
      try {
        let createResult = await createScanner(this.accountId, {
          name: newScanner.name,
          sn: newScanner.sn
        }, this.type);
        await this.getScanners();
        this.resetNewScanner();
        this.$message({
          type: 'success',
          message: '新增掃瞄機成功'
        });
      } catch(error) {
        console.log(error);
        this.newScanner.loading = false;
        this.$message({
          type: 'error',
          message: '新增掃瞄機失敗'
        });
      }
    },
    dropNewScanner() {
      this.resetNewScanner();
    },
    editScanner(index) {
      let editModeIndex = this.scanners.findIndex(printer => {
        return printer.editMode;
      })
      if (editModeIndex != -1) {
        this.$message({
          type: "warning",
          message: "請先儲存編輯中的設定"
        });
        return;
      }

      this.tempScanner = {...this.scanners[index]};
      this.scanners.splice(index, 1, this.scanners[index])
      this.scanners[index].editMode = true;
    },
    saveScanner(index) {
      const scanner = this.scanners[index];
      updateScanner(this.accountId, scanner, this.type)
        .then(updateRes => {
          this.$message({
            type: "success",
            message: "更新掃瞄機設定成功"
          });
          this.scanners[index].editMode = false;
          this.scanners.splice(index, 1, {...this.scanners[index]});
        })
        .catch(updateErr => {
          console.log('updateErr', updateErr);
          this.$message({
            type: "error",
            message: "更新掃瞄機設定失敗"
          });
        });
    },
    abandonEditScanner(index) {
      this.scanners.splice(index, 1, {...this.tempScanner});
    },
    removeScanner(index) {
      const scanner = this.scanners[index];
      deleteScanner(this.accountId,this.type, scanner.sn)
        .then(unbindRes => {
          this.$message({
            type: 'success',
            message: '刪除掃瞄機成功'
          });
          this.scanners.splice(index, 1);
        })
        .catch(unbindErr => {
          console.log('unbindErr', unbindErr);
          this.$message({
            type: 'error',
            message: '刪除掃瞄機失敗'
          });
        })
    },
    InvalidInput(inputScanner) {
      // 檢查輸入的掃瞄機設定格式
      for (let scanner of this.scanners) {
        if (inputScanner === scanner) continue;
        if (inputScanner.sn === scanner.sn) {
          this.$message({
            type: 'error',
            message: '掃瞄機序號重複'
          });
          return true;
        }
      }
      if (!inputScanner.name || !inputScanner.sn) {
        this.$message({
            type: 'error',
            message: '缺少必要欄位'
        });
        return true;
      }
      return false;
    },
    
  },
  watch: {
    editList: function(newVal, oldVal) {
      console.log("editList newVal: ", newVal);
      if (newVal.length > 0) {
        let editStatusData = {
          value: this.value
        };
        this.$emit("edit-status", editStatusData);
      } else {
        let savedStatusData = {
          value: this.value
        };
        this.$emit("saved-status", savedStatusData);
      }
    },
    scannersIsEditing: function(newVal, oldVal) {
      let event = {
        code: 'scanners',
        warning: !!newVal,
      };
      let editDataIndex = this.editList.findIndex(d => d.code == event.code);
      if (event.warning) {
        if (editDataIndex == -1) {
          this.editList.push(event);
        } else {
          let editData = this.editList.find(d => d.code == event.code);
          Object.assign(editData, event);
        }
      } else {
        if (editDataIndex != -1) {
          this.editList.splice(editDataIndex, 1);
        }
      }
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
